import { getCookie, removeCookie, setCookie } from "../cookies/cookies";
import { getUTCDate } from "../getUTCDate/getUTCDate";
export const PASS_VERIFIED_DATE_OF_BIRTH_COOKIE = "passVerifiedDateOfBirth";
export const PASS_VERIFIED_PHONE_COOKIE = "passVerifiedPhone";
export const PASS_VERIFIED_NAME = "passVerifiedName";
export const PASS_VERIFIED_DATA = [
    PASS_VERIFIED_NAME,
    PASS_VERIFIED_PHONE_COOKIE,
    PASS_VERIFIED_DATE_OF_BIRTH_COOKIE,
];
export const getPassVerifiedData = (key) => getCookie(key);
export const setPassVerifiedData = (data, key, ttlInSeconds = 24 * 60 * 60) => {
    const ttlInMs = ttlInSeconds * 1000;
    const ttlOfPassAgeVerification = getUTCDate(ttlInMs);
    setCookie(key, data, "/", ttlOfPassAgeVerification);
};
export const deletePassVerifiedData = (key) => {
    removeCookie(key);
};
export const deleteAllPassUserData = () => {
    PASS_VERIFIED_DATA.forEach((key) => {
        removeCookie(key);
    });
};
//# sourceMappingURL=passVerificationData.js.map